var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupScgGrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 157.89 31.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .grid-ff6428 {\n        fill: #ff6428;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "grid-ff6428",
    d: "M114.11,31.33h-5.06v-13.94c0-4.78,3.89-8.67,8.67-8.67h5.28v5.06h-5.28c-1.99,0-3.61,1.62-3.61,3.61v13.94Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "grid-ff6428",
    x: 126.32,
    y: 8.52,
    width: 5.32,
    height: 22.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "grid-ff6428",
    cx: 128.97,
    cy: 3.48,
    r: 2.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "grid-ff6428",
    d: "M45.01,31.48h-7.6c-8.07,0-14.64-6.57-14.64-14.65s6.57-14.65,14.64-14.65h7.6v5.06h-7.6c-5.29,0-9.59,4.3-9.59,9.59s4.3,9.59,9.59,9.59h7.6v5.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "grid-ff6428",
    d: "M69.28,31.48h-8.29c-8.07,0-14.64-6.57-14.64-14.65s6.57-14.65,14.64-14.65h8.4v5.06h-8.4c-5.29,0-9.59,4.3-9.59,9.59s4.3,9.59,9.59,9.59h3.23v-9.69h5.06v14.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "grid-ff6428",
    d: "M104.46,31.48h-8.29c-8.07,0-14.64-6.57-14.64-14.65s6.57-14.65,14.64-14.65h8.4v5.06h-8.4c-5.29,0-9.59,4.3-9.59,9.59s4.3,9.59,9.59,9.59h3.23v-9.69h5.06v14.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "grid-ff6428",
    d: "M11.75,31.4H.56v-5.06h11.19c1.98,0,4.09-1,4.09-2.86,0-1.62-1.09-3.04-2.66-3.46l-7.1-1.76c-3.6-.96-6.09-4.2-6.09-7.88C0,5.89,3.65,2.24,8.14,2.24h12.1v5.06h-12.1c-1.7,0-3.08,1.38-3.08,3.08,0,1.4.94,2.62,2.29,2.98l7.1,1.76c3.82,1.02,6.46,4.45,6.46,8.36,0,4.52-3.93,7.92-9.15,7.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "grid-ff6428",
    d: "M146.44,31.48c-6.27,0-11.38-5.1-11.38-11.38s5.11-11.38,11.38-11.38h6.39V0h5.06v20.02c0,6.31-5.14,11.45-11.45,11.45ZM146.44,13.78c-3.49,0-6.32,2.84-6.32,6.32s2.84,6.32,6.32,6.32,6.39-2.87,6.39-6.39v-6.25h-6.39Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupScgGrid);
export default __webpack_public_path__ + "static/media/group_SCG_Grid.6673b79f5b4ca6152e991165d4acfe73.svg";
export { ForwardRef as ReactComponent };